(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bnc-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function select(root, tab) {
      root.querySelectorAll('[data-bnc-tab]').forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    function init() {
      document.querySelectorAll('[data-bnc-tabs]').forEach(function (root) {
        if (root.dataset.ready) return;
        root.dataset.ready = '1';
        var tabs = root.querySelectorAll('[data-bnc-tab]');
        if (tabs.length) select(root, tabs[0]);
        root.addEventListener('click', function (e) {
          var t = e.target.closest('[data-bnc-tab]');
          if (t) select(root, t);
        });
        root.addEventListener('keydown', function (e) {
          var t = e.target.closest('[data-bnc-tab]');
          if (!t || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
          var list = Array.prototype.slice.call(root.querySelectorAll('[data-bnc-tab]'));
          var i = list.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
          var n = list[(i + list.length) % list.length];
          n.focus();
          select(root, n);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
